import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from '../../../constant';
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const PurchaseOrderDetails = () => {
  const tableHeaders = [
    "#",
    "Product",
    "Variant",
     "Qty", 
    "Gross/Net",
    "Unit Price",
    "Discount",
    "Tax %",
    "Tax Amount",
    "Total Price",
    "Remarks",
    "Action"
  ];

  const [poData, setPoData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
 id: null,
sa_veemart_po_id: localStorage.getItem("sa_veemart_po_id"),
product_id: "",
variant_id: "",
gross_weight: "",
net_weight: "",
unit_price: "",
discount: "",
tax_percent: "",
tax_amount: "",
total_price: "",
qty: "", // ✅ Added this line
remarks: "",

  });
const navigate = useNavigate();
const [filteredVariants, setFilteredVariants] = useState([]); // 👈 new state
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const [grnData, setGrnData] = useState([]);
const [filteredGrnData, setFilteredGrnData] = useState([]);
const [showGrnModal, setShowGrnModal] = useState(false);
const [pageLoading, setPageLoading] = useState(false);

const [poInfo, setPoInfo] = useState({
  po_number: "",
  po_date: "",
  payment_status: "",
  order_status: "",
  added_by: "",
});

// Fetch PO info from localStorage (saved from previous page)

      const po_id= localStorage.getItem("sa_veemart_po_id");

// Date formatter
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB");
};

  useEffect(() => {
     const data = {
    po_number: localStorage.getItem("po_number"),
    po_date: localStorage.getItem("po_date"),
    payment_status: localStorage.getItem("payment_status"),
    order_status: localStorage.getItem("order_status"),
    added_by: localStorage.getItem("added_by"),
  };
  setPoInfo(data);
      loadInitialData();

  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchPoData();
      await fetchProductData();
      await fetchVariantData();
    } catch (err) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchPoData = async () => {
          const po_id= localStorage.getItem("sa_veemart_po_id");

    try {
      const res = await axios.get(`${var_api}sa_veemart_po_details/getByPoId/${po_id}`);
      setPoData(res.data || []);
    } catch {
      toast.error("Failed to fetch PO details");
    }
  };
const fetchGrnData = async () => {
  setPageLoading(true);
  try {
    const res = await axios.get(`${var_api}sa_veemart_grn/get`);
    const data = Array.isArray(res.data) ? res.data : res.data.data || [];
    setGrnData(data); // store all
  } catch {
    toast.error("Failed to fetch GRN records");
  } finally {
    setPageLoading(false);
  }
};

const handleDownloadExcel = () => {
  if (poData.length === 0) {
    toast.warning("No data to export");
    return;
  }

  // Prepare Excel rows
  const excelData = poData.map((item) => {
    const productName =
      productData.find((p) => p.id === item.product_id)?.product_name || "-";
    const variantName =
      variantData.find((v) => v.id === item.variant_id)?.variant_name || "-";
    const grossNet = `${item.gross_weight || "-"} / ${item.net_weight || "-"}`;

    return {
      "PO Number": poInfo.po_number || "-",
      "PO Date": formatDate(poInfo.po_date),
      Product: productName,
      Variant: variantName,
      "Gross/Net": grossNet,
      "Unit Price": item.unit_price || "-",
      "Total Amount": item.total_price || "-",
    };
  });

  // Create worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "PurchaseOrder");

  // Auto-width for columns
  const colWidths = Object.keys(excelData[0]).map((key) => ({
    wch: Math.max(
      key.length,
      ...excelData.map((row) => String(row[key]).length)
    ) + 2,
  }));
  worksheet["!cols"] = colWidths;

  // Save as file
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(file, `PO_${poInfo.po_number || "report"}.xlsx`);
};






  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setProductData(data);
    } catch {
      toast.error("Failed to fetch products");
    }
  };

  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setVariantData(data);
    } catch {
      toast.error("Failed to fetch variants");
    }
  };
// Filter variants when product changes
useEffect(() => {
  if (formData.product_id) {
    const filtered = variantData.filter(v => v.product_id === Number(formData.product_id));
    setFilteredVariants(filtered);
  } else {
    setFilteredVariants([]); // reset if no product chosen
  }
}, [formData.product_id, variantData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

const handleDownloadPDF = () => {
  if (poData.length === 0) {
    toast.warning("No data to export");
    return;
  }

  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.text("Purchase Order Report", 14, 20);

  doc.setFontSize(11);

  // From Veemart
  doc.text("From: Veemart", 14, 28);

  // Supplier Name (with fallback)
  const supplierName = localStorage.getItem("supplier_name") || "N/A";
  doc.text(`To: ${supplierName}`, 14, 34);

  // Quotation Info
  doc.text(`Quotation Number: ${localStorage.getItem("quotation_number") || "-"}`, 14, 40);
  doc.text(`Quotation Date: ${formatDate(localStorage.getItem("quotation_date"))}`, 14, 46);

  // PO Info
  doc.text(`PO Number: ${poInfo.po_number || "-"}`, 14, 52);
  doc.text(`PO Date: ${formatDate(poInfo.po_date)}`, 14, 58);

  const tableColumn = [
    "Product",
    "Variant",
    "Qty",
    "Gross/Net",
    "Unit Price",
    "Total Price",
  ];

  const tableRows = poData.map((item) => {
    const productName = productData.find(p => p.id === item.product_id)?.product_name || "-";
    const variantName = variantData.find(v => v.id === item.variant_id)?.variant_name || "-";
    return [
      productName,
      variantName,
      item.quantity || "-",
      `${item.gross_weight || "-"} / ${item.net_weight || "-"}`,
      item.unit_price || "-",
      item.total_price || "-",
    ];
  });

  autoTable(doc, {
    startY: 64,
    head: [tableColumn],
    body: tableRows,
    theme: "grid",
    headStyles: { fillColor: [41, 128, 185], halign: 'center' },
    bodyStyles: { halign: 'center' },
    styles: { fontSize: 10 },
  });

  doc.save(`PO_${poInfo.po_number || "report"}.pdf`);
};




  const handleAddClick = () => {
    setFormData({
    id: null,
sa_veemart_po_id: localStorage.getItem("sa_veemart_po_id"),
product_id: "",
variant_id: "",
gross_weight: "",
net_weight: "",
unit_price: "",
discount: "",
tax_percent: "",
tax_amount: "",
total_price: "",
qty: "", // ✅ Added this line
remarks: "",

    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };
useEffect(() => {
  const qty = parseFloat(formData.qty) || 0;
  const unitPrice = parseFloat(formData.unit_price) || 0;
  const total = qty * unitPrice;

  setFormData((prev) => ({
    ...prev,
    total_price: total ? total.toFixed(2) : "",
  }));
}, [formData.qty, formData.unit_price]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.product_id) newErrors.product_id = "Product is required";
    if (!formData.variant_id) newErrors.variant_id = "Variant is required";
     if (!formData.unit_price) {
    newErrors.unit_price = "Unit price is required";
  } else if (isNaN(formData.unit_price) || Number(formData.unit_price) <= 0) {
    newErrors.unit_price = "Enter a valid positive number";
  }
 if (!formData.qty) {
    newErrors.qty = "Quantity is required";
  } else if (isNaN(formData.qty) || Number(formData.qty) <= 0) {
    newErrors.qty = "Enter a valid positive number";
  }
  // ✅ Total Price validation
  if (!formData.total_price) {
    newErrors.total_price = "Total price is required";
  } else if (isNaN(formData.total_price) || Number(formData.total_price) <= 0) {
    newErrors.total_price = "Enter a valid positive number";
  }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}sa_veemart_po_details/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}sa_veemart_po_details/post`, formData);
      }
      toast.success(res?.data?.message || "Record saved successfully!");
      setShowModal(false);
      fetchPoData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save record");
    } finally {
      setLoading(false);
    }
  };
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
   const handleDeleteClick = async () => {
    if (!deleteId) return;
  
    try {
      setLoading(true);
      const res = await axios.delete(`${var_api}sa_veemart_po_details/delete/${deleteId}`);
      toast.success(res?.data?.message || "Record deleted successfully!");
      fetchPoData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete record");
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };
  const filteredData = poData.filter((item) => {
  const productName =
    productData.find((p) => p.id === item.product_id)?.product_name?.toLowerCase() || "";
  const variantName =
    variantData.find((v) => v.id === item.variant_id)?.variant_name?.toLowerCase() || "";
  const qty = String(item.qty || "").toLowerCase();
  const gross = String(item.gross_weight || "").toLowerCase();
  const net = String(item.net_weight || "").toLowerCase();
    const tax_percent = String(item.tax_percent || "").toLowerCase();
  const unit_price = String(item.unit_price || "").toLowerCase();
  const total_price = String(item.total_price || "").toLowerCase();

  const remarks = String(item.remarks || "").toLowerCase();

  const query = searchQuery.toLowerCase();

  return (
    productName.includes(query) ||
    variantName.includes(query) ||
    qty.includes(query) ||
    gross.includes(query) ||
    net.includes(query) ||
    remarks.includes(query)||
    tax_percent.includes(query)||
        unit_price.includes(query)||
    total_price.includes(query)

  );
});

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
 const getPaymentStatus = (status) => {
    switch (Number(status)) {
      case 0:
        return <span className="badge bg-warning text-dark">Pending</span>;
      case 1:
        return <span className="badge bg-success">Paid</span>;
      case 2:
        return <span className="badge bg-info text-dark">Partial</span>;
      default:
        return <span className="badge bg-secondary">Unknown</span>;
    }
  };

  const getOrderStatus = (status) => {
    switch (Number(status)) {
      case 0:
        return <span className="badge bg-secondary">Pending</span>;
      case 1:
        return <span className="badge bg-success">Approved</span>;
      case 2:
        return <span className="badge bg-danger">Cancelled</span>;
      default:
        return <span className="badge bg-light text-dark">Unknown</span>;
    }
  };

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
            <Card className="p-3 mb-3 position-relative">
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h5 className="mb-0">Purchase Order Details</h5>

    {/* 🔙 Back Button */}
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => navigate("/purchase-order")}
    >
      <i className="fas fa-arrow-left me-2"></i> Back to PO List
    </Button>
    
  </div>

  <Row className="g-3">
    <Col xs="auto">
      <strong>PO Number:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
        {poInfo.po_number || "-"}
      </span>
    </Col>

    <Col xs="auto">
      <strong>PO Date:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
        {formatDate(poInfo.po_date)}
      </span>
    </Col>

    <Col xs="auto">
    <strong>Payment Status:</strong> {getPaymentStatus(poInfo.payment_status)}
    </Col>

    <Col xs="auto">
         <strong>Order Status:</strong> {getOrderStatus(poInfo.order_status)}

    </Col>

  
  </Row>
</Card>

              <div className="d-flex justify-content-end mb-3 gap-2">
                 {/* <Button
    variant="info"
    onClick={() => {
      fetchGrnData();
      setShowGrnModal(true);
    }}
  >
    View GRN
  </Button> */}

   <Button variant="success" onClick={handleDownloadPDF}>
    <i className="fas fa-download me-2"></i> Download PDF
  </Button>

  <Button variant="primary" onClick={handleDownloadExcel}>
    <i className="fas fa-file-excel me-2"></i> Download Excel
  </Button>
  
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>{tableHeaders.map((h, i) => <th key={i}>{h}</th>)}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="12" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => {
                        const productName = productData.find(p => p.id === item.product_id)?.product_name || "-";
                        const variantName = variantData.find(v => v.id === item.variant_id)?.variant_name || "-";
                        return (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                            <td>{productName}</td>
                            <td>{variantName}</td>
                            <td>{item.qty}</td>
                            <td>{item.gross_weight}/{item.net_weight}</td>
                            <td>{item.unit_price}</td>
                            <td>{item.discount}</td>
                            <td>{item.tax_percent}</td>
                            <td>{item.tax_amount}</td>
                            <td>{item.total_price}</td>
                            <td>{item.remarks}</td>
                            <td className="text-center">
                                   <button
                                className="btn shadow btn-xs sharp"
                                style={{ backgroundColor: "#007bff", color: "white" }}
                                onClick={() => handleEditClick(item)}
                                title="Edit"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </button>
                                         <button
  className="btn shadow btn-xs sharp"
  style={{ backgroundColor: "#f40c17ff", color: "white" }}
  onClick={() => {
    setDeleteId(item.id);
    setShowDeleteModal(true);
  }}
  title="Delete"
>
  <i className="fas fa-trash"></i>
</button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Purchase Order Detail" : "Add Purchase Order Detail"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
       <Col md={6}>
       <Form.Group className="mb-3">
         <Form.Label>
           Product <span className="text-danger">*</span>
         </Form.Label>
         <Select
           name="product_id"
           value={
             productData
               .filter((p) => p.id === Number(formData.product_id))
               .map((p) => ({ value: p.id, label: p.product_name }))[0] || null
           }
           onChange={(selectedOption) => {
             setFormData((prev) => ({
               ...prev,
               product_id: selectedOption ? selectedOption.value : "",
               variant_id: "", // reset variant when product changes
             }));
             // ✅ Clear product error instantly
             setErrors((prev) => ({ ...prev, product_id: "" }));
           }}
           options={productData.map((p) => ({
             value: p.id,
             label: p.product_name,
           }))}
           placeholder="Select Product"
           isClearable
         />
         {errors.product_id && (
           <div className="text-danger small">{errors.product_id}</div>
         )}
       </Form.Group>
     </Col>
     
            
         <Col md={6}>
       <Form.Group className="mb-3">
         <Form.Label>
           Variant <span className="text-danger">*</span>
         </Form.Label>
         <Select
           name="variant_id"
           value={
             filteredVariants
               .filter((v) => v.id === Number(formData.variant_id))
               .map((v) => ({ value: v.id, label: v.variant_name }))[0] || null
           }
           onChange={(selectedOption) => {
             setFormData((prev) => ({
               ...prev,
               variant_id: selectedOption ? selectedOption.value : "",
             }));
             // ✅ Clear variant error instantly
             setErrors((prev) => ({ ...prev, variant_id: "" }));
           }}
           options={filteredVariants.map((v) => ({
             value: v.id,
             label: v.variant_name,
           }))}
           placeholder={
             formData.product_id ? "Select Variant" : "Select Product First"
           }
           isClearable
           isDisabled={!formData.product_id}
         />
         {errors.variant_id && (
           <div className="text-danger small">{errors.variant_id}</div>
         )}
       </Form.Group>
     </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gross Weight</Form.Label>
                    <Form.Control name="gross_weight" value={formData.gross_weight} onChange={handleInputChange} placeholder="Enter gross weight" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Net Weight</Form.Label>
                    <Form.Control name="net_weight" value={formData.net_weight} onChange={handleInputChange} placeholder="Enter net weight" />
                  </Form.Group>
                </Col>
                <Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label>
      Quantity <span className="text-danger">*</span>
    </Form.Label>
    <Form.Control
      type="number"
      min="1"
      name="qty"
      value={formData.qty}
      onChange={(e) => {
        const value = e.target.value;
        setFormData((prev) => ({ ...prev, qty: value }));
        setErrors((prev) => ({ ...prev, qty: "" }));
      }}
      placeholder="Enter quantity"
    />
    {errors.qty && (
      <div className="text-danger small">{errors.qty}</div>
    )}
  </Form.Group>
</Col>

                       <Col md={4}>
               <Form.Group className="mb-3">
                 <Form.Label>Unit Price <span className="text-danger">*</span></Form.Label>
                 <Form.Control
                   type="number"
                   min="1"
                   name="unit_price"
                   value={formData.unit_price}
                   onChange={(e) => {
                     const value = e.target.value;
                     setFormData((prev) => ({ ...prev, unit_price: value }));
                     setErrors((prev) => ({ ...prev, unit_price: "" }));
                   }}
                   placeholder="Enter unit price"
                 />
                 {errors.unit_price && (
                   <div className="text-danger small">{errors.unit_price}</div>
                 )}
               </Form.Group>
             </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Discount</Form.Label>
                    <Form.Control name="discount" value={formData.discount} onChange={handleInputChange} placeholder="Enter discount" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tax %</Form.Label>
                    <Form.Control name="tax_percent" value={formData.tax_percent} onChange={handleInputChange} placeholder="Enter tax percent" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tax Amount</Form.Label>
                    <Form.Control name="tax_amount" value={formData.tax_amount} onChange={handleInputChange} placeholder="Enter tax amount" />
                  </Form.Group>
                </Col>
                     <Col md={6}>
               <Form.Group className="mb-3">
                 <Form.Label>Total Price <span className="text-danger">*</span></Form.Label>
                 <Form.Control
                   type="number"
                   min="1"
                    name="total_price"
                   value={formData.total_price}
                   onChange={(e) => {
                     const value = e.target.value;
                     setFormData((prev) => ({ ...prev, total_price: value }));
                     setErrors((prev) => ({ ...prev, total_price: "" }));
                   }}
                   placeholder="Enter total price"
                 />
                 {errors.total_price && (
                   <div className="text-danger small">{errors.total_price}</div>
                 )}
               </Form.Group>
             </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control name="remarks" value={formData.remarks} onChange={handleInputChange} placeholder="Enter remarks" />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      disabled={loading}
                      onClick={() =>
                        setFormData({
                      id: null,
sa_veemart_po_id: localStorage.getItem("sa_veemart_po_id"),
product_id: "",
variant_id: "",
gross_weight: "",
net_weight: "",
unit_price: "",
discount: "",
tax_percent: "",
tax_amount: "",
total_price: "",
qty: "", // ✅ Added this line
remarks: "",

                        })
                      }
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
               <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete this record? This action cannot be undone.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="warning" onClick={handleDeleteClick} disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Deleting...
                </>
              ) : (
                "Delete"
              )}
            </Button>
          </Modal.Footer>
        </Modal>
  <Modal show={showGrnModal} onHide={() => setShowGrnModal(false)} centered size="md">
  <Modal.Header closeButton>
    <Modal.Title>GRN Details</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {/* Header row with View Details button */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h6 className="mb-0">All GRN Records</h6>
      <Button
        variant="outline-success"
        size="sm"
        onClick={() => {
          setShowGrnModal(false); // close modal
          navigate("/grn-details"); // navigate to details page
        }}
        title="View GRN Details"
        className="d-flex align-items-center"
      >
        <i className="fas fa-external-link-alt me-2"></i>
        View Details
      </Button>
    </div>

    {pageLoading ? (
      <div className="text-center my-3">
        <div className="spinner-border text-primary" role="status"></div>
        <div>Loading GRN data...</div>
      </div>
    ) : grnData.length === 0 ? (
      <p className="text-muted text-center mb-0">No GRN records found.</p>
    ) : (
      <table className="table table-bordered table-sm mb-0">
        <thead>
          <tr>
            <th>#</th>
            <th>GRN Number</th>
            <th>GRN Date</th>
          </tr>
        </thead>
        <tbody>
          {grnData.map((g, i) => (
            <tr key={g.id}>
              <td>{i + 1}</td>
              <td>{g.grn_number || "-"}</td>
              <td>{formatDate(g.grn_date)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="danger" onClick={() => setShowGrnModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>


      </Card>
      <ToastContainer />
    </>
  );
};

export default PurchaseOrderDetails;
